import React from "react";

export function Section({ children, className = "", dark = false, id }) {
  return (
    <section
      id={id}
      className={`relative ${dark ? "bg-[#0D1110] text-[#F9F8F6]" : ""} ${className}`}
    >
      {dark && <div className="noise-overlay" />}
      <div className="relative z-10">{children}</div>
    </section>
  );
}

export function Container({ children, className = "" }) {
  return <div className={`max-w-7xl mx-auto px-6 md:px-10 ${className}`}>{children}</div>;
}

export function Overline({ children, className = "" }) {
  return <span className={`overline text-primary ${className}`}>{children}</span>;
}

export function PillButton({ children, onClick, variant = "primary", className = "", type = "button", ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 h-12 text-sm font-semibold tracking-wide transition-[transform,background-color,color,box-shadow] duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
  const variants = {
    primary: "bg-primary text-white hover:bg-[#B84726] hover:shadow-lg hover:shadow-primary/20",
    dark: "bg-[#0D1110] text-white hover:bg-black hover:shadow-lg",
    outline: "border border-current bg-transparent hover:bg-black/5",
    light: "bg-white text-[#0D1110] hover:shadow-lg",
  };
  return (
    <button type={type} onClick={onClick} className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
